<template>
  <div class="meteoLegendBox">
    <img
      :src="i_src"
      id="legendInOut"
      class="legend_in_out in"
      @click="change"
    />
    <div id="meteoLegendBox">
      <div class="legendTitleTd">图例</div>
      <div id="meteoLegendTable" style="display: table-row">
        <td id="meteoLegendName" class="legendTitleTd"></td>
        <td colspan="8">
          <div id="legend" class="scaleItem" style="display: inline"></div>
        </td>
      </div>
    </div>

    <div class="latlngBox">
      纬度:<span>{{ lat }}</span> 经度:<span>{{ lng }}</span>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      i_src: "image/in.png",
      boxWidth: null,
      lat: null,
      lng: null,
    };
  },
  methods: {
    change() {
      this.boxWidth = $(".meteoLegendBox").width();
      if ($("#legendInOut").attr("src") === "image/in.png") {
        $("#legendInOut").attr("src", "image/out.png");
        $(".meteoLegendBox").animate(
          {
            right: -this.boxWidth,
          },
          400,
          "linear"
        );
      } else {
        $("#legendInOut").attr("src", "image/in.png");
        $(".meteoLegendBox").animate(
          {
            right: 5,
          },
          400,
          "linear"
        );
      }
    },
    getlo(item) {
      //E经度
      let lo = ToDegrees(item);
      return lo[0] + "°" + lo[1] + "′" + lo[2] + "′′" + "E";
    },
    getla(item) {
      //N纬度
      let la = ToDegrees(item);
      return la[0] + "°" + la[1] + "′" + la[2] + "′′" + "N";
    },
  },
  mounted() {
    this.change();
    this.$eventBus.$on("latlng", (e) => {
      this.lat = this.getla(e.latlng.lat);
      this.lng = this.getlo(e.latlng.lng);
    });
  },
};
</script>

<style lang="less" scoped>
.meteoLegendBox {
  display: none;
  position: absolute;
  bottom: 65px;
  right: -300px;
  min-width: 300px;

  background-size: 100% 100%;
  z-index: 3;
}
.meteoLegendBox img {
  position: absolute;
  left: -30px;
  width: 30px;
  height: 45px;
  cursor: pointer;
}
#meteoLegendBox {
  height: 45px;
  padding: 0 10px;

  .legendTitleTd {
    text-align: center;
    color: #fff;
  }

  #meteoLegendTable {
    #meteoLegendName {
      color: #fff;
      font-size: 14px;
    }

    #legend {
      width: fit-content;
      width: -webkit-fit-content;
      width: -moz-fit-content;
      height: 20px;
      color: white;
      border-radius: 10px;
      z-index: 2;
      align-items: center;
      zoom: 0.9;
    }
  }
}

.latlngBox {
  color: #fff;
  padding: 0 5px;
  min-width: 450px;

  span {
    display: inline-block;
    margin: 0 5px;
    width: 150px;
  }
}
</style>